import { Input } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import { TMobileSignupForm } from '../../form/form';
import { StepLayout } from '../../StepLayout/StepLayout';

const PHONE_REGEX = /^[\d +/()-]{8,}$/;

// DIT-688. Phone number. Reads/writes the shared mobile signup form store
// (DIT-664).
export const PhoneScreen = () => {
  const { t } = useLingui();
  const { register, watch } = useFormContext<TMobileSignupForm>();

  const phone = watch('phoneNumber');
  const isValid = PHONE_REGEX.test(phone);

  return (
    <StepLayout
      stageTitle={t`Tell us about yourself`}
      heading={t`Your phone number`}
      subHeading={t`We’ll use your phone number to contact you about your application.`}
      ctaDisabled={!isValid}
    >
      <Input
        {...register('phoneNumber')}
        type="tel"
        label={t`Main phone number`}
        placeholder={t`e.g. 07700 900000`}
        className="fs-mask"
      />
    </StepLayout>
  );
};
